import {
  UPDATING_USER_PICTURE,
  SETTINGS_USER_CHANGE_INFO,
  SETTINGS_USER_CHANGE_LANGUAGE,
  SHOW_ALERT,
  GDPR_DELETE_ACCOUNT_REQUESTING,
  GDPR_EXPORT_DATA_REQUESTING,
  HIDE_ALERT,
} from "./constants";

export const AlertType = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
} as const;

type AlertTypeEnum = typeof AlertType[keyof typeof AlertType];

export const updateUserPicture = (payload: {
  name: string;
  uri: string;
  userId: string;
  picture: string;
}) => {
  return {
    type: UPDATING_USER_PICTURE,
    payload,
  };
};

// beaucoup trop de chose modifié différente
// il faut faire l'inventaire
export const changeUserInfo = payload => {
  return {
    type: SETTINGS_USER_CHANGE_INFO,
    payload,
  };
};

export const changeUserLanguage = (payload: string) => {
  return {
    type: SETTINGS_USER_CHANGE_LANGUAGE,
    payload,
  };
};

export const showAlert = (payload: {
  title: string;
  message?: string;
  alertType?: AlertTypeEnum;
}) => {
  return {
    type: SHOW_ALERT,
    payload,
  };
};

export const hideAlert = () => {
  return {
    type: HIDE_ALERT,
  };
};

export const askGDPRExportDataRequest = payload => {
  return {
    type: GDPR_EXPORT_DATA_REQUESTING,
    payload,
  };
};

export const askGDPRDeleteAccountRequest = payload => {
  return {
    type: GDPR_DELETE_ACCOUNT_REQUESTING,
    payload,
  };
};
